export default function Progress() {
  return {}
}
